import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-lfsa-options-export',
  templateUrl: './lfsa-options-export.component.html',
  styleUrls: ['./lfsa-options-export.component.css']
})
export class LfsaOptionsExportComponent implements OnInit {

  @Output() devolverAccionExport = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    
  }

  exportar() {
    this.devolverAccionExport.emit('csv');
  }

}
